import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import {
  followCreator,
  followCreatorFailure,
  followCreatorReset,
  followCreatorSuccess,
  unfollowCreator,
  unfollowCreatorSuccess,
} from "../creatorProfile/actions";

import {
  getMyFollowers,
  getMyFollowersSuccess,
  getMyFollowersFailure,
  getMyFollowersPortionSuccess,
  getMyFollowersPortion,
  getMyFollowersPortionFailure,
  getMyFollowingsSuccess,
  getMyFollowingsPortionSuccess,
  getMyFollowings,
  getMyFollowingsPortion,
  getMyFollowingsFailure,
  getMyFollowingsPortionFailure,
  followersReset,
  getFollowersByIdSuccess,
  getFollowersByIdPortionSuccess,
  getFollowersById,
  getFollowersByIdPortion,
  getFollowersByIdFailure,
  getFollowersByIdPortionFailure,
  getFollowingsById,
  getFollowingsByIdPortion,
  getFollowingsByIdSuccess,
  getFollowingsByIdPortionSuccess,
  getFollowingsByIdFailure,
  getFollowingsByIdPortionFailure,
  favoriteFollowing,
  unfavoriteFollowing,
  favoriteFollowingSuccess,
  unfavoriteFollowingSuccess,
  favoriteFollowingReset,
} from "./actions";

const initialState = {
  data: [],
  nextOffset: undefined,
  totalCount: undefined,
  isFollowSuccess: undefined,
  isFavoriteSuccess: undefined,
  error: undefined,
  isLoading: true,
  isFollowUpdating: false,
  isFavoriteUpdating: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(followersReset.type, () => initialState)
    .addCase(followCreator.type, (state) => ({
      ...state,
      isFollowUpdating: true,
    }))
    .addCase(unfollowCreator.type, (state) => ({
      ...state,
      isFollowUpdating: true,
    }))
    .addCase(unfollowCreatorSuccess, (state, { payload }) => {
      state.isFollowUpdating = false;
      const { userId, type = "data" } = payload;
      const data = state[type];

      const followingIndex = data.findIndex(
        (item) => item?.user?.id === userId,
      );

      if (followingIndex !== -1) {
        data.splice(followingIndex, 1);
      }

      return state;
    })
    .addCase(followCreatorSuccess.type, (state, { payload }) => {
      state.isFollowSuccess = true;
      state.isFollowUpdating = false;

      const { userId, type = "data", id } = payload;
      const data = state[type];

      const followingIndex = data.findIndex(
        (item) => item?.user?.id === userId,
      );

      const item = data.at(followingIndex);

      if (item && id) {
        item.id = id;
      }

      if (item) {
        item.user.isFollowed = true;
      }

      return state;
    })
    .addCase(followCreatorFailure.type, (state) => ({
      ...state,
      isFollowUpdating: false,
    }))
    .addCase(followCreatorReset.type, (state) => ({
      ...state,
      isFollowSuccess: initialState.isFollowSuccess,
    }))
    .addCase(favoriteFollowing.type, (state) => ({
      ...state,
      isFavoriteUpdating: true,
    }))
    .addCase(favoriteFollowingSuccess.type, (state) => {
      state.isFavoriteSuccess = true;
      state.isFavoriteUpdating = false;
      return state;
    })
    .addCase(favoriteFollowingReset.type, (state) => ({
      ...state,
      isFavoriteSuccess: initialState.isFavoriteSuccess,
    }))
    .addCase(unfavoriteFollowing.type, (state) => ({
      ...state,
      isFavoriteUpdating: true,
    }))
    .addCase(unfavoriteFollowingSuccess, (state) => {
      state.isFavoriteUpdating = false;
      return state;
    })
    .addMatcher(
      isAnyOf(
        getMyFollowersPortionSuccess,
        getMyFollowingsPortionSuccess,
        getFollowersByIdPortionSuccess,
        getFollowingsByIdPortionSuccess,
      ),
      (state, { payload }) => {
        return {
          ...state,
          ...payload,
          data: [...state.data, ...payload.data],
          isLoading: false,
        };
      },
    )
    .addMatcher(isAnyOf(followCreator, unfollowCreator), (state) => ({
      ...state,
      isFollowUpdating: true,
    }))
    .addMatcher(
      isAnyOf(
        getMyFollowersSuccess,
        getMyFollowingsSuccess,
        getFollowersByIdSuccess,
        getFollowingsByIdSuccess,
      ),
      (state, { payload }) => {
        const _favorites = [...payload.data].filter(
          (el) => el.isFavorite === true,
        );
        const _others = [...payload.data].filter(
          (el) => el.isFavorite === false,
        );
        return {
          ...state,
          ...payload,
          favorites: [..._favorites],
          others: [..._others],
          isLoading: false,
        };
      },
    )
    .addMatcher(
      isAnyOf(
        getMyFollowers,
        getMyFollowersPortion,
        getMyFollowings,
        getMyFollowingsPortion,
        getFollowersById,
        getFollowersByIdPortion,
        getFollowingsById,
        getFollowingsByIdPortion,
      ),
      (state) => ({
        ...state,
        isLoading: true,
      }),
    )
    .addMatcher(
      isAnyOf(
        getMyFollowersFailure,
        getMyFollowersPortionFailure,
        getMyFollowingsFailure,
        getMyFollowingsPortionFailure,
        getFollowersByIdFailure,
        getFollowersByIdPortionFailure,
        getFollowingsByIdPortionFailure,
        getFollowingsByIdFailure,
      ),
      (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
    );
});
